module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1c089ce6cb7e194b6d947f407c2d8469.1c089ce6.png";